import React from 'react';

const FeedCoverPhoto = props => {
  const { coverPhoto, keyID = 'feedCoverPhoto' } = props;
  if (!coverPhoto) return null;
  return (
    <div key={keyID}>
      <img src={coverPhoto} />
    </div>
  );
};

export default FeedCoverPhoto;
